module.exports = __webpack_public_path__ + "img/19_Lower-Rectum.a8b65afd.png";